// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-table-page {
  background: radial-gradient(120% 120% at 20% 20%, #f5f7fb, #e7ecf7 55%, #dfe6f5);
  border-radius: 20px;
  padding: 18px;
  border: 1px solid rgba(12, 20, 39, 0.06);
}

.ui-table-hero {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.ui-table-hero__title {
  margin: 0 0 6px;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #0f172a;
}

.ui-table-hero__subtitle {
  margin: 0;
  color: #4b5563;
  font-size: 13px;
}

.ui-table-hero__metrics {
  display: inline-flex;
  gap: 10px;
  flex-wrap: wrap;
}

.ui-table-metric {
  background: #ffffff;
  border: 1px solid rgba(12, 20, 39, 0.08);
  border-radius: 14px;
  padding: 10px 12px;
  min-width: 140px;
  box-shadow: 0 16px 40px rgba(45, 55, 72, 0.12);
}

.ui-table-metric__label {
  display: block;
  color: #6b7280;
  font-size: 12px;
  letter-spacing: 0.3px;
  margin-bottom: 4px;
}

.ui-table-metric__value {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}

.ui-table-grid {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
}

.ui-table-card {
  background: #ffffff;
  border: 1px solid rgba(12, 20, 39, 0.08);
  border-radius: 16px;
  box-shadow: 0 18px 60px rgba(45, 55, 72, 0.14);
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.ui-table-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px 10px;
  border-bottom: 1px solid rgba(12, 20, 39, 0.06);
}

.ui-table-card__title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

.ui-table-card__subtitle {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 13px;
}

.ui-table-card__search {
  width: min(280px, 100%);
}

.ui-table-card__body {
  padding: 10px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 0;
}

.ui-table-surface {
  border-radius: 12px;
  border: 1px solid rgba(12, 20, 39, 0.06);
  overflow: hidden;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.03), #ffffff);
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.ui-table-scroll {
  width: 100%;
  overflow: auto;
  max-height: calc(100vh - 360px);
}

.ui-table-surface table {
  width: 100%;
}

.ui-table-paginator {
  bottom: 0;
  position: sticky;
  z-index: 5;
  background: #ffffff;
  border-top: 1px solid rgba(12, 20, 39, 0.06);
}

.ui-table-paginator .mat-paginator-container {
  padding: 10px 12px;
}

.action-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
}

.action-group {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 6px 8px;
  border: 1px solid rgba(12, 20, 39, 0.06);
  border-radius: 10px;
  background: #f8fafc;
}

.action-group--info {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.04), #f8fafc);
}

.action-group--edit {
  background: linear-gradient(135deg, rgba(107, 114, 128, 0.04), #ffffff);
}

.action-group--duplicate {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.06), #ffffff);
}

.action-group--danger {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.06), #fff5f5);
}

.action-group--approve {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.06), #f0fdf4);
}

.action-label {
  font-size: 12px;
  color: #374151;
  font-weight: 700;
  background: #ffffff;
  border: 1px solid rgba(12, 20, 39, 0.08);
  border-radius: 999px;
  padding: 4px 8px;
}

.ui-table-page--fill {
  flex: 1 1 auto;
  display: grid;
  grid-template-rows: auto 1fr;
  gap: var(--ui-space-3);
  min-height: 0;
  margin-top: var(--ui-space-3);
  color: var(--ui-color-text);
}

.ui-table-header {
  display: grid;
  gap: var(--ui-space-2);
}

.ui-table-header .ui-table-hero {
  margin-bottom: 0;
}

.ui-table-badge {
  display: inline-flex;
  align-items: center;
  gap: var(--ui-space-2);
  padding: var(--ui-space-2) var(--ui-space-3);
  border: 1px solid var(--ui-color-primary-border);
  border-radius: var(--ui-radius-pill);
  background: var(--ui-color-primary-tint);
  color: var(--ui-color-primary-strong);
  font-size: var(--ui-font-size-xs);
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.ui-table-panel {
  display: flex;
  flex-direction: column;
  gap: var(--ui-space-2);
  min-height: 0;
  padding: var(--ui-space-2);
  border: 1px solid var(--ui-color-border);
  border-radius: var(--ui-radius-lg);
  background: var(--ui-color-surface);
  box-shadow: var(--ui-shadow-card);
}

.ui-table-panel .ui-table-surface {
  flex: 1 1 auto;
  border-radius: var(--ui-radius-md);
}

.ui-table-panel .ui-table-scroll {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
}

.ui-table-data {
  width: 100%;
  border-spacing: 0;
}

.ui-table-state {
  padding: var(--ui-space-5) var(--ui-space-3);
  color: var(--ui-color-text-muted);
  font-size: var(--ui-font-size-md);
  text-align: center;
}

.ui-table-state mat-progress-spinner {
  margin: 0 auto;
}

@media (max-width: 720px) {
  .ui-table-scroll {
    max-height: none;
  }
}
`, "",{"version":3,"sources":["webpack://./projects/admin/src/components/ui-table/ui-table.styles.css"],"names":[],"mappings":"AAAA;EACE,gFAAgF;EAChF,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,sEAAsE;EACtE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,gDAAgD;EAChD,oCAAoC;EACpC,wCAAwC;EACxC,qCAAqC;EACrC,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,0BAA0B;EAC1B,wCAAwC;EACxC,kCAAkC;EAClC,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,iCAAiC;EACjC,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".ui-table-page {\n  background: radial-gradient(120% 120% at 20% 20%, #f5f7fb, #e7ecf7 55%, #dfe6f5);\n  border-radius: 20px;\n  padding: 18px;\n  border: 1px solid rgba(12, 20, 39, 0.06);\n}\n\n.ui-table-hero {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n}\n\n.ui-table-hero__title {\n  margin: 0 0 6px;\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: #0f172a;\n}\n\n.ui-table-hero__subtitle {\n  margin: 0;\n  color: #4b5563;\n  font-size: 13px;\n}\n\n.ui-table-hero__metrics {\n  display: inline-flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.ui-table-metric {\n  background: #ffffff;\n  border: 1px solid rgba(12, 20, 39, 0.08);\n  border-radius: 14px;\n  padding: 10px 12px;\n  min-width: 140px;\n  box-shadow: 0 16px 40px rgba(45, 55, 72, 0.12);\n}\n\n.ui-table-metric__label {\n  display: block;\n  color: #6b7280;\n  font-size: 12px;\n  letter-spacing: 0.3px;\n  margin-bottom: 4px;\n}\n\n.ui-table-metric__value {\n  font-size: 18px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.ui-table-grid {\n  display: grid;\n  gap: 14px;\n  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));\n}\n\n.ui-table-card {\n  background: #ffffff;\n  border: 1px solid rgba(12, 20, 39, 0.08);\n  border-radius: 16px;\n  box-shadow: 0 18px 60px rgba(45, 55, 72, 0.14);\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.ui-table-card__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 16px 10px;\n  border-bottom: 1px solid rgba(12, 20, 39, 0.06);\n}\n\n.ui-table-card__title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.ui-table-card__subtitle {\n  margin: 4px 0 0;\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.ui-table-card__search {\n  width: min(280px, 100%);\n}\n\n.ui-table-card__body {\n  padding: 10px 12px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-height: 0;\n}\n\n.ui-table-surface {\n  border-radius: 12px;\n  border: 1px solid rgba(12, 20, 39, 0.06);\n  overflow: hidden;\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.03), #ffffff);\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.ui-table-scroll {\n  width: 100%;\n  overflow: auto;\n  max-height: calc(100vh - 360px);\n}\n\n.ui-table-surface table {\n  width: 100%;\n}\n\n.ui-table-paginator {\n  bottom: 0;\n  position: sticky;\n  z-index: 5;\n  background: #ffffff;\n  border-top: 1px solid rgba(12, 20, 39, 0.06);\n}\n\n.ui-table-paginator .mat-paginator-container {\n  padding: 10px 12px;\n}\n\n.action-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.action-group {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 6px 8px;\n  border: 1px solid rgba(12, 20, 39, 0.06);\n  border-radius: 10px;\n  background: #f8fafc;\n}\n\n.action-group--info {\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.04), #f8fafc);\n}\n\n.action-group--edit {\n  background: linear-gradient(135deg, rgba(107, 114, 128, 0.04), #ffffff);\n}\n\n.action-group--duplicate {\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.06), #ffffff);\n}\n\n.action-group--danger {\n  background: linear-gradient(135deg, rgba(239, 68, 68, 0.06), #fff5f5);\n}\n\n.action-group--approve {\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.06), #f0fdf4);\n}\n\n.action-label {\n  font-size: 12px;\n  color: #374151;\n  font-weight: 700;\n  background: #ffffff;\n  border: 1px solid rgba(12, 20, 39, 0.08);\n  border-radius: 999px;\n  padding: 4px 8px;\n}\n\n.ui-table-page--fill {\n  flex: 1 1 auto;\n  display: grid;\n  grid-template-rows: auto 1fr;\n  gap: var(--ui-space-3);\n  min-height: 0;\n  margin-top: var(--ui-space-3);\n  color: var(--ui-color-text);\n}\n\n.ui-table-header {\n  display: grid;\n  gap: var(--ui-space-2);\n}\n\n.ui-table-header .ui-table-hero {\n  margin-bottom: 0;\n}\n\n.ui-table-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--ui-space-2);\n  padding: var(--ui-space-2) var(--ui-space-3);\n  border: 1px solid var(--ui-color-primary-border);\n  border-radius: var(--ui-radius-pill);\n  background: var(--ui-color-primary-tint);\n  color: var(--ui-color-primary-strong);\n  font-size: var(--ui-font-size-xs);\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n}\n\n.ui-table-panel {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ui-space-2);\n  min-height: 0;\n  padding: var(--ui-space-2);\n  border: 1px solid var(--ui-color-border);\n  border-radius: var(--ui-radius-lg);\n  background: var(--ui-color-surface);\n  box-shadow: var(--ui-shadow-card);\n}\n\n.ui-table-panel .ui-table-surface {\n  flex: 1 1 auto;\n  border-radius: var(--ui-radius-md);\n}\n\n.ui-table-panel .ui-table-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  max-height: none;\n}\n\n.ui-table-data {\n  width: 100%;\n  border-spacing: 0;\n}\n\n.ui-table-state {\n  padding: var(--ui-space-5) var(--ui-space-3);\n  color: var(--ui-color-text-muted);\n  font-size: var(--ui-font-size-md);\n  text-align: center;\n}\n\n.ui-table-state mat-progress-spinner {\n  margin: 0 auto;\n}\n\n@media (max-width: 720px) {\n  .ui-table-scroll {\n    max-height: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
